var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13,
    fill: "#FFE137",
    stroke: "#282828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2866 11.3829C24.2866 11.3829 22.5899 13.7478 20.9524 13.7478C20.296 13.7723 19.6563 13.5383 19.1706 13.096C18.685 12.6538 18.3923 12.0387 18.3555 11.3829C18.3555 9.80709 21.5391 8.92252 24.2866 11.3829Z",
    fill: "#808080",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7422 18.8606C16.5408 19.5842 16.1079 20.222 15.5098 20.6763C14.9117 21.1307 14.1813 21.3767 13.4302 21.3767C12.6791 21.3767 11.9486 21.1307 11.3505 20.6763C10.7524 20.222 10.3196 19.5842 10.1182 18.8606L8.12523 11.7018C8.02176 11.3328 8.04685 10.9395 8.19638 10.5866C8.3459 10.2337 8.61098 9.94218 8.94809 9.75984C10.3086 8.9692 11.8541 8.55273 13.4277 8.55273C15.0013 8.55273 16.5468 8.9692 17.9074 9.75984C18.2446 9.94207 18.5097 10.2336 18.6593 10.5865C18.8088 10.9395 18.8338 11.3328 18.7302 11.7018L16.7422 18.8606Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33537 12.4578C8.48935 12.2197 8.70072 12.0242 8.95004 11.8892C10.3106 11.0985 11.8561 10.6821 13.4297 10.6821C15.0032 10.6821 16.5488 11.0985 17.9093 11.8892C18.1582 12.0241 18.3692 12.2193 18.5232 12.4569L18.7346 11.6983C18.9461 10.9363 18.6054 9.29717 17.9118 8.92195C16.5513 8.13131 15.0057 7.71484 13.4321 7.71484C11.8586 7.71484 10.313 8.13131 8.95251 8.92195C8.25802 9.29635 7.91571 10.9379 8.12965 11.6983L8.33537 12.4578Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7419 18.8591C16.5405 19.5827 16.1077 20.2204 15.5096 20.6748C14.9115 21.1291 14.181 21.3751 13.4299 21.3751C12.6788 21.3751 11.9484 21.1291 11.3503 20.6748C10.7522 20.2204 10.3193 19.5827 10.1179 18.8591L8.12496 11.7002C7.91266 10.9399 8.25497 9.2983 8.94782 8.9239C10.3083 8.13327 11.8539 7.7168 13.4275 7.7168C15.001 7.7168 16.5466 8.13327 17.9071 8.9239C18.6032 9.29912 18.9447 10.9383 18.7299 11.7002L16.7419 18.8591Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2255 18.9495C11.0555 19.1733 10.9514 19.4401 10.9248 19.7199C10.8981 19.9997 10.9501 20.2813 11.0749 20.5332C11.1997 20.785 11.3922 20.997 11.631 21.1454C11.8697 21.2937 12.1451 21.3725 12.4261 21.3728H14.4339C14.7155 21.3729 14.9915 21.2943 15.2308 21.1458C15.4701 20.9973 15.663 20.7848 15.7879 20.5324C15.9128 20.28 15.9646 19.9977 15.9375 19.7174C15.9104 19.4371 15.8054 19.17 15.6344 18.9462L15.6056 18.9092C15.3473 18.5797 15.0174 18.3132 14.6409 18.13C14.2644 17.9468 13.8512 17.8516 13.4325 17.8516C13.0137 17.8516 12.6005 17.9468 12.224 18.13C11.8475 18.3132 11.5176 18.5797 11.2593 18.9092L11.2255 18.9495Z",
    fill: "#FFA694",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 12.6018C10.625 12.8261 10.7141 13.0413 10.8728 13.1999C11.0314 13.3585 11.2466 13.4477 11.4709 13.4477C11.6952 13.4477 11.9104 13.3585 12.069 13.1999C12.2277 13.0413 12.3168 12.8261 12.3168 12.6018C12.3168 12.3774 12.2277 12.1623 12.069 12.0036C11.9104 11.845 11.6952 11.7559 11.4709 11.7559C11.2466 11.7559 11.0314 11.845 10.8728 12.0036C10.7141 12.1623 10.625 12.3774 10.625 12.6018Z",
    fill: "#1A1A1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4922 12.6018C14.4922 12.8261 14.5813 13.0413 14.7399 13.1999C14.8986 13.3585 15.1137 13.4477 15.3381 13.4477C15.5624 13.4477 15.7776 13.3585 15.9362 13.1999C16.0949 13.0413 16.184 12.8261 16.184 12.6018C16.184 12.3774 16.0949 12.1623 15.9362 12.0036C15.7776 11.845 15.5624 11.7559 15.3381 11.7559C15.1137 11.7559 14.8986 11.845 14.7399 12.0036C14.5813 12.1623 14.4922 12.3774 14.4922 12.6018Z",
    fill: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5547 19.3848V20.0727",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 19.3848V20.0727",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57031 11.3829C2.57031 11.3829 4.26705 13.7478 5.90453 13.7478C6.56084 13.7721 7.2005 13.538 7.68608 13.0958C8.17166 12.6536 8.46443 12.0386 8.50147 11.3829C8.50147 9.80709 5.31783 8.92252 2.57031 11.3829Z",
    fill: "#808080",
    stroke: "#1A1A1A",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCowIcon);
export default __webpack_public_path__ + "static/media/cowIcon.2378f5ea30e4afced1b80ece97c3b7dc.svg";
export { ForwardRef as ReactComponent };